const issueOptions = [
    {
        value: 30,
        label: 'Bug/Platform Issue',
    },
    {
        value: 34,
        label: 'Content Error/Issue',
    },
    {
        value: 35,
        label: 'Recognised Browser',
    },
    {
        value: 16,
        label: 'Infrastructure & facilities',
    },
    {
        value: 17,
        label: 'Attendance, Leave, and OD Related',
    },
    { value: 18, label: 'Marks & Grades Related' },
    { value: 19, label: 'Doubt Clarification' },
    {
        value: 20,
        label: 'Work-integration: Internship',
    },
    {
        value: 21,
        label: 'Work-integration: Simulated Work',
    },
    {
        value: 22,
        label: 'Internship Eligibility Markers',
    },
    {
        value: 23,
        label: 'Evaluation & feedback',
    },
    {
        value: 24,
        label: 'Placement Process & Related',
    },
    {
        value: 25,
        label: 'Kalvium Policies',
    },
    {
        value: 26,
        label: 'Code of conduct Breach',
    },
    {
        value: 28,
        label: 'Live sessions',
    },
    {
        value: 29,
        label: 'Bonus Points on Professionalism',
    },
    {
        value: 31,
        label: 'Feature Request',
    },
    { value: 32, label: 'Others' },
]

export default issueOptions
